var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.908,
    height: 20,
    viewBox: "0 0 20.908 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout",
    transform: "translate(0 -0.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_57638",
    d: "M162.823,220.327H150A.664.664,0,0,1,150,219h12.828a.664.664,0,1,1,0,1.327Zm0,0",
    transform: "translate(-142.578 -209.331)",
    fill: "#e2351e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_57639",
    d: "M153.542,142.057a.658.658,0,0,1-.469-.195l-3.539-3.539a.664.664,0,0,1,0-.939l3.539-3.539a.664.664,0,0,1,.939.939l-3.07,3.07,3.07,3.07a.663.663,0,0,1-.47,1.132Zm0,0",
    transform: "translate(-142.922 -127.523)",
    fill: "#e2351e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_57640",
    d: "M10.022,20.332A10,10,0,1,1,19.349,6.674a.683.683,0,0,1-1.272.5,8.636,8.636,0,1,0,0,6.319.683.683,0,0,1,1.272.5A9.97,9.97,0,0,1,10.022,20.332Zm0,0",
    fill: "#e2351e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.cd15aeb2.svg";
export { ForwardRef as ReactComponent };